export const getPayPalClientIdFromRootDocument = () => {
  const root = document.getElementById("root");
  return root?.dataset["paypalClientId"];
};
